//import 'whatwg-fetch'
import { auth } from '.'
import { HOST } from './constants'

const BASE = HOST + '/rest/system/'
const DEPLOY = 'deploy/'
const CONFIG = 'config/'
const UPLOAD = 'upload/'

const httpUpload = (url, file, type, cb) => {
  return new Promise( (resolve, reject) => {
    const http = new XMLHttpRequest()
    http.open('POST', url, true)
    http.setRequestHeader('Content-Type', type)
    http.setRequestHeader('Authorization', auth.getBasicAuth())
    http.onload = e => resolve(JSON.parse(e.currentTarget.response))
    http.onerror = e => reject({status: e.status, statusText: e.statusText})
    if (http.upload && cb) http.upload.onprogress = cb
    http.send(file)
  })
}

const encode = (url, params) => {
  const encoded = Object.keys(params).map(k => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
  return url + '?' + encoded.join('&')
}

export default {
  upload(action, file, onProgress) {
    const type = 'application/octet-stream'
    switch (action) {
      case 'deploy': return httpUpload(BASE+DEPLOY+file.name, file, type, onProgress)
      case 'config': return httpUpload(BASE+CONFIG+file.name, file, type, onProgress)
      default: return httpUpload(BASE+UPLOAD+file.name, file, type, onProgress)
    }
  },
  send(url, params, file, onProgress) {
    const query = encode(url, params)
    const type = 'application/octet-stream'
    return httpUpload(query, file, type, onProgress)
  },
  download() {}
}



// WEBPACK FOOTER //
// ./src/lib/files.js